import { SettingsParser } from "./settings-parser";
import { ViewObjectSettings } from "../settings/view-object-settings";
import { getSizeSettings } from "../../utils/get-size-settings";

export class ViewObjectParser extends SettingsParser {
  constructor() {
    super();
    this.parsedFieldNames = ["x", "y", "width", "height"];
  }

  static createSettings(settings, defaultSettings) {
    if (settings === undefined) {
      return undefined;
    }
    let parsedSettings = {
      x: getSizeSettings(settings.x ?? defaultSettings?.x, 0, 0),
      y: getSizeSettings(settings.y ?? defaultSettings?.y, 0, 0),
      width: getSizeSettings(settings.width ?? defaultSettings?.width, 0, 1),
      height: getSizeSettings(settings.height ?? defaultSettings?.height, 0, 1)
    };
    return parsedSettings;
  }

  parse(settings, defaultSettings) {
    let parsedSettings = ViewObjectParser.createSettings(settings, defaultSettings);
    if (parsedSettings === undefined) {
      return undefined;
    }
    SettingsParser.parseRestFields(settings, defaultSettings, this.parsedFieldNames, parsedSettings);
    return new ViewObjectSettings(parsedSettings);
  }
}
